module.exports = "/images/logo-isos.svg?6355cdb7b39731e21ac3dba686367e82";